import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../services/store';
import { PURGE } from 'redux-persist';

const initialState = {
  projectId: 0,
  status: 'uninitialized',
  queue: [],
};

export const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    projectIdChanged: (state, { payload }) => {
      state.projectId = payload;
    },
    statusChanged: (state, { payload }) => {
      state.status = payload;
    },
    queueChanged: (state, { payload }) => {
      state.queue = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { statusChanged, queueChanged, projectIdChanged } =
  uploadSlice.actions;

export const selectUploadProjectId = (state: RootState) =>
  state.upload.projectId;
export const selectUploadStatus = (state: RootState) => state.upload.status;
export const selectQueue = (state: RootState) => state.upload.queue;

export default uploadSlice.reducer;
